import projectBase from '../projectBase'

export default class Social {
  constructor(selector) {
    this.el = document.querySelectorAll(selector)

    if (this.el.length) {
      this.initialize()
    }
  }

  initialize() {
    this.title =
      (document.head.querySelector('meta[property$=title]') || {}).content ||
      ''
    this.url = location.href
    ;[...this.el].forEach((item) => {
      const provider = item.dataset.provider
      item.href = this.getShareUrl(provider)

      this.bind(item)
    })
  }

  bind(item) {
    item.addEventListener('click', this.onClickShare)
  }

  getShareUrl(provider) {
    const encodedUrl = encodeURIComponent(this.url)
    const result = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${this.title}`,
      hatebu: `http://b.hatena.ne.jp/add?&url=${encodedUrl}`,
      pocket: `https://getpocket.com/edit?url=${encodedUrl}&title=${this.title}`,
    }[provider]

    return result
  }

  onClickShare(e) {
    const target = e.currentTarget
    window.open(target.href, '_blank', 'width=480, height=480')
    e.preventDefault()
  }
}
